import { useRef } from 'react';
import { Button } from 'reactstrap';
//import NewDataTable from './NewDataTable';
import { GridLayout, HorizontalMenu } from './ui';
import IFrameContainer, { IFrameContainerImperativeHandle } from './ui/IFrameContainer';

const Home = () => {
    const iframeRef = useRef<IFrameContainerImperativeHandle>(null);

    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    const menu = <HorizontalMenu items={Array.from(new Array(12), (i, k) => ({
        key: k.toString(),
        important: k % 3 === 1,
        el: `Item ${k}`
    }))} />;

    const head = <style>{`body { color: red }`}</style>

    return <>
        <Button type="button" onClick={() => iframeRef.current?.print()}>Stampa</Button>
        <IFrameContainer ref={iframeRef} style={{ width: '100%' }} head={head}>
            <GridLayout header={menu}>
                {/*<NewDataTable />*/}
            </GridLayout>
        </IFrameContainer>
    </>
}

export default Home;